"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT = void 0;
const PRODUCT = exports.PRODUCT = 'product';
//# sourceMappingURL=constants.js.map